import styles from './index.module.scss';
const ContactIcon = ({children})=>{
   return(
      <div className={styles['contact-icon']}>
           {children}
      </div>
   )
}
export default ContactIcon;